import cx from 'classnames';
import { Switch } from 'react-md';

const SwitchInput = ({ id, className, disabled, control, setControl, onChange, ...rest }) => {
  return (
    <Switch
      id={id}
      name={id}
      disabled={disabled}
      className={cx({ active: control, 'read-only-switch': disabled }, className)}
      checked={control}
      onChange={e => {
        if (onChange) {
          onChange(e);
        }

        if (setControl) {
          setControl(e.currentTarget.checked);
        }
      }}
      {...rest}
    />
  );
};

export default SwitchInput;
